/* eslint-disable no-unused-vars */
import React, { useState } from 'react'

import PageHeader from '../../../components/PageHeader'
import { useTheme } from '../../../utils/ThemeColorContext'
import DefaultPage from '../DefaultPage'
import { useNavigate } from 'react-router-dom'
import PrimaryButton from '../../../components/buttons/PrimaryButton'
import FormInput from '../../../components/inputs/FormInput'
import AgreeToTerms from '../../../components/cards/AgreeToTerms'
import { useDispatch, useSelector } from 'react-redux'
import Spinner from '../../../components/Spinner'
import { useEffect } from 'react'
import { myHtml } from '../../../api/dummyData'
import { ActionTypes } from '../../../redux/Constants/actionTypes'
import { isSafari } from '../../../utils/browser'
import {
  getAgreementDocs,
} from '../../../redux/Actions/getMethods'
import { getAnalytics, logEvent } from 'firebase/analytics'
import { conversionAPI, AcceptLoan } from '../../../redux/Actions/postMethods'
import { AppStyles } from '../../../assets/styles/AppStyles'
import SpinnerLarge from '../../../components/SpinnerLarge'
import TagManager from 'react-gtm-module'


function LoanAgreement() {
  const { loading, token } = useSelector((state) => state.authReducer)
  const dispatch = useDispatch()
  const { loadingWholeScreen, getApplication, agreementDoc, agreement, profile } = useSelector(
    (state) => state.dataReducer,
  )
  const [docHtml, setDocHtml] = useState('')
  const { color, isSmallScreen } = useTheme()
  const navigate = useNavigate()
  const [isOn, setIsOn] = useState(false)
  const [signature, setSignatire] = useState(null)
  const [err, setErr] = useState(false)
  const [networkErr, setNetworkErr] = useState(false)

  const parser = new DOMParser()
  const doc = parser.parseFromString(docHtml, 'text/html')
  
  const id = getApplication[0]?.id

  useEffect(() => {
    dispatch({ type: ActionTypes.AGREEMENT, payload: isOn })

    if (getApplication[0]?.id) {
      const getCrditDocs = async () => {
        const success = await dispatch(
          getAgreementDocs(
            getApplication[0]?.id,
            'credit',
            ActionTypes.GET_AGREMENT_DOCS,
          ),
        )
        success && setDocHtml(success)
      }
      getCrditDocs()
    }
  }, [getApplication[0]?.id])

  useEffect(() => {
    dispatch({ type: ActionTypes.AGREEMENT, payload: isOn })
  }, [isOn])

  // const alreadyChecked = JSON.parse(
  //   localStorage.getItem(`loan-agreement-${token?.email}`),
  // )
  
  // ==================== Checking user status  =======================//
  useEffect(() => {
    const temp = async () => {
      dispatch({ type: ActionTypes.LOADING_SUCCESS_WHOLE_SCREEN })
      // const myID = await dispatch(getApplications())
      if (getApplication[0]?.status === 'APPROVED') {
        dispatch({ type: ActionTypes.LOADING_FAIL_WHOLE_SCREEN })
        //navigate('/signagreement')
        // do nothing
      } else {
        dispatch({ type: ActionTypes.LOADING_FAIL_WHOLE_SCREEN })
        navigate('/address-detail')
      }
    }
    temp()
  }, [])

  const getSignatureData = async () => {
    if (!agreement) {
      setErr(true)
    } else {
      setErr(false)
      const success = await dispatch(
        AcceptLoan(id, signature, setNetworkErr),
      )
      if (success) {
        await sendAnalytics()
        localStorage.removeItem(`loan-agreement-${token?.email}`)
        localStorage.removeItem(`bankConfirm-${token?.email}`)
        localStorage.removeItem(`add_accounts-${token?.email}`)
        localStorage.removeItem(`signature-${token?.email}`)
        localStorage.removeItem(`direct-debit-${token?.email}`)
        localStorage.removeItem('add_account')
        localStorage.removeItem('bank')
        localStorage.removeItem('SelectedBank')
        localStorage.removeItem(`bank-${token?.email}`)
        localStorage.removeItem(`add-another-bank-account-${token?.email}`)
        localStorage.setItem(`most-recent-application-reason-${token?.email}`, getApplication[0]?.reason)
        navigate('/manageloan')
      }
    }
    // Save the signature data to a database or send it to a server here.
  }

  const sendAnalytics = async () => {
    const eventReference = 'world_record_'  // event ref replacement for 'accepted_loan_offer_'
    const eventName = 'WorldRecord' // event name replacement for 'Accepted Loan Offer'
    if (window.fbq) {
      window.fbq('trackCustom', eventName,
        {
          /* applicationId: getApplication[0]?.id,
          loan_amount: getApplication[0]?.max_amount,
          loan_fee_percent: getApplication[0]?.fee_percentage, */
        },
        {eventID: `${eventReference}${getApplication[0]?.id}`}
      )
      window.fbq('track', 'Subscribe', {}, {eventID: `subscribe_${getApplication[0]?.id}`})
    }
    dispatch(
      conversionAPI({
        eventName: eventName,
        eventSourceUrl: `${process.env.REACT_APP_FRONTEND_URL}signagreement`,
        phoneNumber: token?.phone_number,
        email: token?.email,
        fName: token?.given_name,
        lName: token?.family_name,
        cognitoUserId: token?.sub,
        customData: {
          applicationId: getApplication[0]?.id,
          loan_amount: getApplication[0]?.amount,
          loan_fee_percent: getApplication[0]?.fee_percentage,
        },
        dateOfBirth: token?.birthdate,
        userAgent: navigator.userAgent,
        eventId: `${eventReference}${getApplication[0]?.id}`,
        eventReference: eventReference,
      }),
    )
    const ttEventReference = 'accepted_loan_offer_'
    const ttEventName = 'Purchase'
    if(window.ttq) {
      window.ttq.track(ttEventName, {
        "contents": [
          {
            "content_id": getApplication[0]?.id,
            "price": getApplication[0]?.fee_percentage,
          }
        ],
        "value": getApplication[0]?.amount,
        "currency": "GBP"
      }, {
        "event_id": `${ttEventReference}${getApplication[0]?.id}`
      });
    }
    if (window.snaptr) {
      window.snaptr('track', 'CUSTOM_EVENT_3', {
        price: getApplication[0]?.fee_percentage,
        currency: 'GBP',
        transaction_id: getApplication[0]?.id,
        description: getApplication[0]?.max_amount,
        user_email: token?.email,
        user_phone_number: token?.phone_number,
      })
    }
    if (window.gtag) {
      let user_data = {}
      if (
        profile?.first_name &&
        profile?.family_name &&
        profile?.address?.postcode
      ) {
        let address = { country: 'UK' }
        address.first_name = profile?.first_name
        address.last_name = profile?.family_name
        address.postal_code = profile?.address.postcode
        if (profile?.address?.line_1)
          address.street = profile?.address?.line_1
        if (profile?.address?.town) address.city = profile?.address.town
        if (
          profile?.address?.postal_county ||
          profile?.address?.traditional_county
        )
          address.region =
            profile?.address?.postal_county ||
            profile?.address?.traditional_county
        user_data = {
          email: token?.email,
          phone_number: token?.phone_number,
          address: address,
        }
      } else {
        user_data = {
          email: token?.email,
          phone_number: token?.phone_number,
        }
      }
      window.gtag('event', 'conversion', {
        send_to: process.env.REACT_APP_LOAN_ACCEPTED_GTAG_CONVERSION,
        loan_amount: getApplication[0]?.amount,
        loan_fee_percent: getApplication[0]?.fee_percentage,
        user_data: user_data,
        value: getApplication[0]?.amount,
        currency: 'GBP',
        transaction_id: getApplication[0]?.id,
      })
    }
    const tagManagerArgs = {
      dataLayer: {
        event: 'loan_accepted',
        user_id: token?.sub,
        loan_amount: getApplication[0]?.max_amount,
        loan_fee_percentage: getApplication[0]?.fee_percentage,
        reason: getApplication[0]?.reason,
        status: getApplication[0]?.status,
        application: getApplication[0],
      }
    }
    TagManager.dataLayer(tagManagerArgs)
    const analytics = getAnalytics()
    logEvent(analytics, 'accepted_loan_application_client_side', {
      loan_amount: getApplication[0]?.amount,
      loan_fee_percent: getApplication[0]?.fee_percentage,
      platform: 'web',
    })
  }

  return (
    <DefaultPage>
      {loadingWholeScreen ? (
        <SpinnerLarge />
      ) : (
      <div className="relative container mx-auto  md:w-[564px]  md:space-y-10  ">
        <PageHeader
          // arrow={true}
          title={'Your loan agreement'}
          description={`Scroll to the bottom to accept the terms of the loan`}
          backButtonTitle={'Back'}
          prevRoute={'/signagreement'}
        />
        <div
          style={{
            backgroundColor: color.White,
            margin: isSmallScreen && 'auto',
          }}
          className="rounded-3xl p-6 space-y-6 "
        >
          {/* <div
            style={{
              backgroundColor: color.White,
              borderColor: color.MidGrey,
            }}
            className="key-facts space-y-6 overflow-y-scroll h-[500px] "
          > */}
            <p>Key Facts</p>
            <div
              className={isSafari ? 'key-facts-safari' : ''}
              style={{ margin: 0 }}
              dangerouslySetInnerHTML={{ __html: agreementDoc }}
            />
          {/* </div> */}
          <AgreeToTerms
            setIsOn={setIsOn}
            isOn={isOn}
            title={'I accept the terms of the loan'}
          // name={`loan-agreement-${token?.email}`}
          // alreadyChecked={alreadyChecked}
          />
          <div className="flex flex-col justify-end space-y-6 w-full">
            <FormInput
              placeholder={'Sign here'}
              type={'text'}
              onChange={(e) => {
                setSignatire(e.target.value)
              }}
              name={'signature'}
              value={signature}
            />
          </div>
          {err && (
            <p
              className="text-center"
              style={{ ...AppStyles.Caption1, color: color.SoftPink }}
            >
              {'Please view and accept your loan agreement'}
            </p>
          )}
          {networkErr && (
            <p
              className="text-center"
              style={{ ...AppStyles.Caption1, color: color.SoftPink }}
            >
              {'Please try again some time later'}
            </p>
          )}
        </div>
        <div
          style={{
            marginTop: /* isSmallScreen &&  */'24px',
            /* background: !isSmallScreen && 'linear-gradient(0deg, #F5F7FC 0%, rgba(245, 247, 252, 0) 100%)', */
          }}
          /* className={
            isSmallScreen ? (
              `mt-10 md:max-w-[588px] m-[auto] fixed w-full bottom-0 px-6 pb-6 md:p-0 flex flex-col-reverse gap-5 md:gap-10 md:flex-row bg-[#F5F7FC]`
            ) : (
              `px-6 pb-6 md:p-0 fixed bottom-0 md:relative  w-full `
            )
          } */
          className='px-6 pb-6 md:p-0 bottom-0 md:relative  w-full'
        >
          {/* {isSmallScreen && (
            <>
              <div
                className="absolute inset-x-0 top-[-32px] h-[24px] bg-gradient-to-t from-[#F5F7FC] to-[#F5F7FC00] pointer-events-none"
              ></div>
              <div
                className="absolute inset-x-0 top-[-8px] h-[8px] bg-[#F5F7FC] pointer-events-none"
              />
            </>
          )} */}
          <PrimaryButton
            id={'signagreement-primary'}
            disabled={(!isOn || !signature)}
            onClick={() => {
              if (loading) {
                return
              }
              window.heap &&
                window.heap.track('uc_loan_terms_agreed', {
                  action_name: 'tap',
                  action_details: 'ucLoanTermsAgreed',
                })
                window.heap &&
                  window.heap.track('uc_loan_agreement_signed', {
                    action_name: 'tap',
                    action_details: 'usLoanAgreementSigned',
                  })
              getSignatureData()
            }}
            text={loading ? <Spinner /> : 'Accept Loan'}
            className={'md:w-[260px]'}
          />
        </div>
      </div>
      )}
    </DefaultPage>
  )
}

export default LoanAgreement
